export default class Settings {
    constructor() {        
    }

    UserDataFtp: number = 100;
    UserDataWeight?: number;
}